module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Eptingen-8cf93ceebd15fcddeed19d137b0c351f.png";